export enum InputProduct {
    Chemicals = "CHEMICALS", 
    Fertilizer = "FERTILIZERS",
    Seeds = "SEEDS",
    Transport = "TRANSPORT",
    Day_Old_Chicks = "DAY_OLD_CHICKS",
    Chick_Feed = "CHICK_FEED",
    Vitamins = "VITAMINS",
    Vaccines = "VACCINES",
    Supplement = "SUPPLEMENT"

}